// adminBilling.action.js
import axios from "../helpers/axios"
import swal from "sweetalert"
import { adminBillingConstants } from "./constants"
import { getUserById } from "./user.actions"

const buildQuery = (params = {}) => {
    const query = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.append(key, value)
        }
    })

    return query.toString()
}

const normalizeBillingData = (fourthArg, fifthArg) => {
    const data = {}

    if (fourthArg && typeof fourthArg === 'object' && !Array.isArray(fourthArg)) {
        Object.assign(data, fourthArg)
    }

    if (fifthArg && typeof fifthArg === 'object' && !Array.isArray(fifthArg)) {
        Object.assign(data, fifthArg)
    }

    if (typeof fourthArg === 'string' && fourthArg !== 'all' && fourthArg !== 'updatedPictures' && fourthArg !== 'picturesNotUpdated') {
        data.searchName = fourthArg
    }

    if (typeof fifthArg === 'string') {
        data.statusFilter = fifthArg
    }

    return data
}

export const getAllTransactionsAdmin = (
    sort = 'createdAtMinus',
    pageNumber = 0,
    pageSize = 20,
    updatedPictures,
    additionalData = {}
) => {
    return async (dispatch) => {
        dispatch({ type: adminBillingConstants.GET_ALL_TRANSACTIONS_REQUEST })

        try {
            const data = normalizeBillingData(updatedPictures, additionalData)

            const query = buildQuery({
                page: pageNumber,
                limit: pageSize,
                sort,
                search: data.searchName,
                status: data.status,
                type: data.transactionType,
                targetModel: data.targetModel
            })

            const res = await axios.get(`/billing/transactions/all?${query}`)

            if (res.status === 200) {
                dispatch({
                    type: adminBillingConstants.GET_ALL_TRANSACTIONS_SUCCESS,
                    payload: res.data
                })
            }
        } catch (error) {
            dispatch({
                type: adminBillingConstants.GET_ALL_TRANSACTIONS_FAILURE,
                payload: error?.response?.data?.error || error.message
            })
        }
    }
}

export const searchTransactionsAdmin = (
    searchName = '',
    sortType = 'createdAtMinus',
    sortSearch,
    additionalData = {}
) => {
    return async (dispatch) => {
        dispatch({ type: adminBillingConstants.GET_ALL_TRANSACTIONS_REQUEST })

        try {
            const data = normalizeBillingData(sortSearch, additionalData)

            const query = buildQuery({
                search: searchName,
                sort: sortType || 'createdAtMinus',
                page: 0,
                limit: data.pageSize || 50,
                status: data.status,
                type: data.transactionType,
                targetModel: data.targetModel
            })

            const res = await axios.get(`/billing/transactions/all?${query}`)

            if (res.status === 200) {
                dispatch({
                    type: adminBillingConstants.GET_ALL_TRANSACTIONS_SUCCESS,
                    payload: res.data
                })
            }
        } catch (error) {
            dispatch({
                type: adminBillingConstants.GET_ALL_TRANSACTIONS_FAILURE,
                payload: error?.response?.data?.error || error.message
            })
        }
    }
}

export const getAllPromosAdmin = (
    sort = 'createdAtMinus',
    pageNumber = 0,
    pageSize = 20,
    updatedPictures,
    additionalData = {}
) => {
    return async (dispatch) => {
        dispatch({ type: adminBillingConstants.GET_ALL_PROMOS_REQUEST })

        try {
            const data = normalizeBillingData(updatedPictures, additionalData)

            const query = buildQuery({
                page: pageNumber,
                limit: pageSize,
                sort,
                search: data.searchName,
                status: data.statusFilter || 'all'
            })

            const res = await axios.get(`/billing/promocodes/all?${query}`)

            if (res.status === 200) {
                dispatch({
                    type: adminBillingConstants.GET_ALL_PROMOS_SUCCESS,
                    payload: res.data
                })
            }
        } catch (error) {
            dispatch({
                type: adminBillingConstants.GET_ALL_PROMOS_FAILURE,
                payload: error?.response?.data?.error || error.message
            })
        }
    }
}

export const searchPromosAdmin = (
    searchName = '',
    sortType = 'createdAtMinus',
    sortSearch,
    additionalData = {}
) => {
    return async (dispatch) => {
        dispatch({ type: adminBillingConstants.GET_ALL_PROMOS_REQUEST })

        try {
            const data = normalizeBillingData(sortSearch, additionalData)

            if (typeof sortSearch === 'string') {
                data.statusFilter = sortSearch
            }

            const query = buildQuery({
                search: searchName,
                sort: sortType || 'createdAtMinus',
                page: 0,
                limit: data.pageSize || 50,
                status: data.statusFilter || 'all'
            })

            const res = await axios.get(`/billing/promocodes/all?${query}`)

            if (res.status === 200) {
                dispatch({
                    type: adminBillingConstants.GET_ALL_PROMOS_SUCCESS,
                    payload: res.data
                })
            }
        } catch (error) {
            dispatch({
                type: adminBillingConstants.GET_ALL_PROMOS_FAILURE,
                payload: error?.response?.data?.error || error.message
            })
        }
    }
}

export const savePromoCodeAdmin = (payload, additionalData = {}) => {
    return async (dispatch) => {
        dispatch({ type: adminBillingConstants.CREATE_PROMO_REQUEST })

        try {
            const res = await axios.post(`/billing/promocode/save`, payload)

            if (res.status === 201 || res.status === 200) {
                dispatch({ type: adminBillingConstants.CREATE_PROMO_SUCCESS })
                swal("Успех", res.data.message, "success")
                dispatch(getAllPromosAdmin('createdAtMinus', 0, additionalData.pageSize || 20, undefined, additionalData))
                return true
            }
        } catch (error) {
            swal("Ошибка", error?.response?.data?.error || error.message, "error")

            dispatch({
                type: adminBillingConstants.CREATE_PROMO_FAILURE,
                payload: error?.response?.data?.error || error.message
            })

            return false
        }
    }
}

export const togglePromoCodeAdmin = (id, additionalData = {}) => {
    return async (dispatch) => {
        dispatch({ type: adminBillingConstants.TOGGLE_PROMO_REQUEST })

        try {
            const res = await axios.patch(`/billing/promocode/toggle/${id}`)

            if (res.status === 200) {
                dispatch({ type: adminBillingConstants.TOGGLE_PROMO_SUCCESS })
                dispatch(getAllPromosAdmin('createdAtMinus', 0, additionalData.pageSize || 20, undefined, additionalData))
                return true
            }
        } catch (error) {
            swal("Ошибка", error?.response?.data?.error || error.message, "error")

            dispatch({
                type: adminBillingConstants.TOGGLE_PROMO_FAILURE,
                payload: error?.response?.data?.error || error.message
            })

            return false
        }
    }
}

export const archivePromoCodeAdmin = (id, additionalData = {}) => {
    return async (dispatch) => {
        dispatch({ type: adminBillingConstants.TOGGLE_PROMO_REQUEST })

        try {
            const res = await axios.patch(`/billing/promocode/archive/${id}`)

            if (res.status === 200) {
                dispatch({ type: adminBillingConstants.TOGGLE_PROMO_SUCCESS })
                swal("Архив", "Промокод скрыт из списка", "success")
                dispatch(getAllPromosAdmin('createdAtMinus', 0, additionalData.pageSize || 20, undefined, additionalData))
                return true
            }
        } catch (error) {
            swal("Ошибка", error?.response?.data?.error || error.message, "error")

            dispatch({
                type: adminBillingConstants.TOGGLE_PROMO_FAILURE,
                payload: error?.response?.data?.error || error.message
            })

            return false
        }
    }
}

export const modifyBalanceAdmin = (targetModel, targetId, amount, description) => {
    return async (dispatch) => {
        dispatch({ type: adminBillingConstants.MODIFY_BALANCE_REQUEST })

        try {
            const res = await axios.post('/billing/admin/modify', {
                targetModel,
                targetId,
                amount,
                description
            })

            if (res.status === 200) {
                dispatch({ type: adminBillingConstants.MODIFY_BALANCE_SUCCESS })
                swal("Успех", `Баланс успешно обновлен!`, "success")
                dispatch(getUserById(targetId))
                return true
            }
        } catch (error) {
            swal("Ошибка", error?.response?.data?.error || error.message, "error")

            dispatch({
                type: adminBillingConstants.MODIFY_BALANCE_FAILURE,
                payload: error?.response?.data?.error || error.message
            })

            return false
        }
    }
}